
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return require("next/dist/pages/_error");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_error"])
      });
    }
  